import {
  Grid,
  Typography,
  Modal,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { formsNRCTime } from '../../../../data/forms/nrc/nrcDropdownOptions';

export default function UpdateStoreHoursModal({
  isOpen,
  handleClose,
  updatedHours,
  setForm,
}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prevForm => ({
      ...prevForm,
      updatedHours: {
        ...prevForm.updatedHours,
        [name]: value,
      },
    }));
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Grid
        container
        spacing={2}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%', m: '60%' },
          maxHeight: '80vh',
          overflowY: 'auto',
          bgcolor: 'var(--dust-white)',
          p: 4,
        }}
      >
        <Grid size={12}>
          <Typography
            id='modal-modal-title'
            sx={{ fontFamily: 'BrightstarSans-Regular', fontSize: '25px' }}
          >
            {'Update Store Hours'}
          </Typography>
        </Grid>
        <Grid size={6}>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Sunday (Open)'}</InputLabel>
            <Select
              value={updatedHours.sundayOpen}
              label={'Sunday (Open)'}
              onChange={handleChange}
              name='sundayOpen'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Monday (Open)'}</InputLabel>
            <Select
              value={updatedHours.mondayOpen}
              label={'Monday (Open)'}
              onChange={handleChange}
              name='mondayOpen'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Tuesday (Open)'}</InputLabel>
            <Select
              value={updatedHours.tuesdayOpen}
              label={'Tuesday (Open)'}
              onChange={handleChange}
              name='tuesdayOpen'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Wednesday (Open)'}</InputLabel>
            <Select
              value={updatedHours.wednesdayOpen}
              label={'Wednesday (Open)'}
              onChange={handleChange}
              name='wednesdayOpen'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Thursday (Open)'}</InputLabel>
            <Select
              value={updatedHours.thursdayOpen}
              label={'Thursday (Open)'}
              onChange={handleChange}
              name='thursdayOpen'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Friday (Open)'}</InputLabel>
            <Select
              value={updatedHours.fridayOpen}
              label={'Friday (Open)'}
              onChange={handleChange}
              name='fridayOpen'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Saturday (Open)'}</InputLabel>
            <Select
              value={updatedHours.saturdayOpen}
              label={'Saturday (Open)'}
              onChange={handleChange}
              name='saturdayOpen'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={6}>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Sunday (Close)'}</InputLabel>
            <Select
              value={updatedHours.sundayClose}
              label={'Sunday (Close)'}
              onChange={handleChange}
              name='sundayClose'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Monday (Close)'}</InputLabel>
            <Select
              value={updatedHours.mondayClose}
              label={'Monday (Close)'}
              onChange={handleChange}
              name='mondayClose'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Tuesday (Close)'}</InputLabel>
            <Select
              value={updatedHours.tuesdayClose}
              label={'Tuesday (Close)'}
              onChange={handleChange}
              name='tuesdayClose'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Wednesday (Close)'}</InputLabel>
            <Select
              value={updatedHours.wednesdayClose}
              label={'Wednesday (Close)'}
              onChange={handleChange}
              name='wednesdayClose'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Thursday (Close)'}</InputLabel>
            <Select
              value={updatedHours.thursdayClose}
              label={'Thursday (Close)'}
              onChange={handleChange}
              name='thursdayClose'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Friday (Close)'}</InputLabel>
            <Select
              value={updatedHours.fridayClose}
              label={'Friday (Close)'}
              onChange={handleChange}
              name='fridayClose'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>{'Saturday (Close)'}</InputLabel>
            <Select
              value={updatedHours.saturdayClose}
              label={'Saturday (Close)'}
              onChange={handleChange}
              name='saturdayClose'
            >
              {formsNRCTime.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid size={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: 'var(--vega-blue)' }}
            onClick={handleClose}
          >
            {'Done'}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
